// Progressive enhancement for the auth pages: any control carrying
// data-loading-label swaps its contents for a spinner and that label once
// activated, and locks its siblings so a slow redirect cannot be double-submitted.
//
// The activated control is deliberately NOT given the `disabled` property - only
// aria-disabled plus pointer-events. A disabled submit button is dropped from the
// form payload by the browser, which would silently strip consent's
// name="decision" value and turn "Authorise" into an invalid request.

// The spinner is decorative only: it carries aria-hidden and no role. role="status"
// alongside aria-hidden="true" cancel each other out anyway, and the label text
// applyLoading puts next to it ("Signing in…") already carries the meaning.
function makeSpinner() {
  const s = document.createElement('span')
  s.className = 'spinner'
  s.setAttribute('aria-hidden', 'true')
  return s
}

function applyLoading(el) {
  const label = el.getAttribute('data-loading-label')
  el.replaceChildren(makeSpinner(), document.createTextNode(label))
  el.setAttribute('aria-disabled', 'true')
  el.style.pointerEvents = 'none'
}

function lockOthers(controls, except) {
  controls.forEach((el) => {
    if (el === except) return
    el.setAttribute('aria-disabled', 'true')
    el.style.pointerEvents = 'none'
    if (el.tagName === 'BUTTON') el.disabled = true
  })
}

export function initLoadingStates(root = document) {
  const controls = Array.from(root.querySelectorAll('[data-loading-label]'))
  if (controls.length === 0) return

  controls.forEach((el) => {
    el.addEventListener('click', () => {
      applyLoading(el)
      lockOthers(controls, el)
    })
  })
}
